//アコーディオン
document.querySelectorAll(".acco-btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    const item = btn.closest(".acco-item");
    const content = item.querySelector(".acco-content");
    const isOpen = btn.classList.toggle("is-active");

    content.classList.toggle("is-acco", isOpen);

    if (isOpen) {
      // 開く：一旦autoにせず、実寸heightを入れる
      content.style.height = content.scrollHeight + "px";

      // 開き切ったら auto にして、リサイズや文字量変化に追従させる
      const onEnd = (e) => {
        if (e.propertyName === "height") {
          content.style.height = "auto";
          content.removeEventListener("transitionend", onEnd);
        }
      };
      content.addEventListener("transitionend", onEnd);

    } else {
      // 閉じる：autoだと0にアニメできないので、実寸→0の順にする
      content.style.height = content.scrollHeight + "px";
      requestAnimationFrame(() => {
        content.style.height = "0px";
      });
    }
  });
});


document.querySelectorAll('.footer-nav-first a').forEach((trigger) => {
  trigger.addEventListener('click', (e) => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      e.preventDefault();
      trigger.closest('.footer-nav-item').classList.toggle('is-open');
    }
  });
});
